import React, { useEffect, useState } from "react";
import "./css/Home.css";
import axios from "axios";
import { useNavigate, Link } from "react-router-dom";
import ArticleIcon from "@mui/icons-material/Article";
import WebIcon from "@mui/icons-material/Web";
import PeopleIcon from "@mui/icons-material/People";
import MarkUnreadChatAltIcon from "@mui/icons-material/MarkUnreadChatAlt";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import { Typography } from "@mui/material";

const Home = () => {
  const navigate = useNavigate();
  useEffect(() => {
    async function getInfo() {
      try {
        const { data } = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/verify`,
          {
            withCredentials: true,
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
          }
        );
        // Store.addNotification({
        //   title: data.message,
        //   message: "",
        //   type: "success",
        //   insert: "top",
        //   container: "bottom-center",
        //   animationIn: ["animate__animated", "animate__fadeIn"],
        //   animationOut: ["animate__animated", "animate__fadeOut"],
        //   dismiss: {
        //     duration: 2000,
        //     onScreen: true,
        //   },
        // });
        console.log(data);
        if (data.message === "Please login first") {
          navigate("/adminLogin");
        }
      } catch (error) {
        console.log(error);
      }
    }
    getInfo();
  }, []);
  return (
    <div className="homeContainer">
      <div className="upperpart">
        <div className="logo">
          <img src="images/chcommune_blue.jpeg"></img>
        </div>
        <div className="description">
          <div className="Intro">Join the ChCommune Family.</div>
          <div className="Intro">
            From the first click to the keys in your hand, our dedicated team{" "}
          </div>
          <div className="Intro">
            is here to make your experience smooth and enjoyable.
          </div>
        </div>
      </div>
      <div className="options">
        <div className="blogs">
          <Link to="/blog" className="links">
            <ArticleIcon className="icons"></ArticleIcon>
            <Typography>Blogs</Typography>
          </Link>
        </div>
        <div className="website">
          <Link to="/website" className="links">
            <WebIcon className="icons"></WebIcon>
            <Typography>Website</Typography>
          </Link>
        </div>
        <div className="commune">
          <Link to="/commune" className="links">
            <PeopleIcon className="icons"></PeopleIcon>
            <Typography>Commune</Typography>
          </Link>
        </div>
       
        <div className="notifications">
          <Link to="/notifications" className="links">
            <NotificationsActiveIcon className="icons"></NotificationsActiveIcon>
            <Typography>Notifications</Typography>
          </Link>
        </div>
        <div className="users">
          <Link to="/userprofiles" className="links">
            <ManageAccountsIcon className="icons"></ManageAccountsIcon>
            <Typography>Users</Typography>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Home;
